import { html } from 'lit';
import 'lit/decorators.js';
import { pdsCustomElement as customElement } from '../../decorators/pds-custom-element';
import { PdsElement } from '../PdsElement';
import styles from './footnotes.scss?inline';
import '../footnote-item/footnote-item';
import { requiredSlot } from '../../decorators/requiredSlot';

/**
 * @summary This component creates a card container for other elements
 *
 * @slot default Required: This slot should contain one or more pds-footnote-item elements to supply the content of the footnotes.
 */
@customElement('pds-footnotes', {
  category: 'component',
  type: 'component',
  state: 'stable',
  styles,
})
export class PdsFootnotes extends PdsElement {
  /**
   * @internal
   */
  get classNames() {
    return {};
  }

  @requiredSlot(['default'])
  render() {
    return html` <ol role="list" class="${this.getClass()}">
      <slot></slot>
    </ol>`;
  }
}
